import styled from 'styled-components/macro'

export const JobSubTitle = styled.h2`
  font-weight: 600;
  font-size: 14px;
  margin: 5px 0 20px;
  color: ${({ theme }) => theme.colors.gray9};
`
